<template>
  <v-card outlined class="table-layout mt-7 py-5">
    <v-row>
      <v-col cols="12" md="4" class="px-10">
        <h3 class="display-2 font-weight-medium mb-7">% Hoàn thành KPI</h3>
        <v-progress-linear
          v-if="reports.kpi !== ''"
          :value="+reports.kpi"
          color="success"
          height="25"
          style="z-index: 0;"
        >
          <template v-slot="{ value }">
            <strong>{{ Math.round(value) }}%</strong>
          </template>
        </v-progress-linear>
      </v-col>
      <v-col cols="12" md="8" class="px-10">
      <v-simple-table class="table-layout border-table">
        <template v-slot:default>
          <thead>
            <tr>
              <th class="font-weight-regular">Đơn hàng</th>
              <th class="font-weight-regular">Doanh thu thành công</th>
              <th class="font-weight-regular">Tỉ lệ chốt thành công</th>
            </tr>
          </thead>
          <tbody>
            <tr>
              <td>
                <h3>{{ reports.countSuccessOrders === '' ? '' : reports.countSuccessOrders }}
                  / {{ reports.countInitOrders === '' ? '' : reports.countInitOrders }}</h3>
              </td>
              <td>
                <h3>{{formatPrice(reports.successTurnOver)}} / {{formatPrice(reports.initTurnOver)}}</h3>
              </td>
              <td>
                <h3>{{ reports.departmentSuccessLatchRatio === '' ? '' : +reports.departmentSuccessLatchRatio + '%' }}
                  / {{ reports.departmentInitLatchRatio === '' ? '' : +reports.departmentInitLatchRatio + '%' }}</h3>
              </td>
            </tr>
          </tbody>
        </template>
    </v-simple-table>
      </v-col>
    </v-row>


  </v-card>
</template>
<script>
export default {
  props: {
    reports: {
      type: Object,
      default: () => ({})
    }
  }
};
</script>

<style lang="scss" scoped>
  table {
    thead th {
      background-color: #244e74;
      color: #ffffff!important;
    }
    tbody td {
      background-color: #ccdef6;
    }
  }
</style>
